// removed by extract-text-webpack-plugin
module.exports = {"benefitWrapper":"_2EkTNsqbgIVq59MvrK2SJh","title":"_2NBPBOHRcZqGgKn3FLCuUn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorBenefits/RealtorBenefits.scss
// module id = 1745
// module chunks = 0